<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      row-id="sampleBarcode"
      :checkboxConfig="{
        reserve: true,
        highlight: false,
        trigger: 'row',
        range: true
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:sampleStatus="{ row }">
           <el-tag
          size="mini"
          :type="row.sampleStatus === 'Y' ? 'info' : row.sampleStatus === 'S' ? 'success':'danger'"
        >
          {{ row.sampleStatus === 'Y' ? '新增' : row.sampleStatus === 'S' ? '已审核':'已删除' }}
        </el-tag>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          style="width:100px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:status="{ row }">
        <el-tag size="mini" :type="row.orgStatus === 'Y' ? 'light' : 'warning'">
          {{ row.v_orgStatus }}
        </el-tag>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      default: null,
      type: Object
    },
    loading: {
      default: false
    }
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true,
        custom: true
      },
      tableColumns: [
        {
          field: 'seq',
          width: 60,
          align: 'center',
          fixed: 'left',
          type: 'seq'
        },
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'checkbox'
        },
        {
          field: 'defaultImageUrl',
          width: 120,
          title: this.$l('INDEX.table_label_image') || '图片',
          align: 'center',
          fixed: 'left',
          slots: { default: 'defaultImageUrl' }
        },
        {
          title: this.$l('INDEX.sample_style_no') || '样品款号',
          field: 'sampleStyleNo',
          minWidth: 160,
          headerAlign: 'left',
          align: 'left',
          fixed: 'left',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('INDEX.sample_barcode') || '样品条码',
          field: 'sampleBarcode',
          minWidth: 160,
          fixed: 'left',
          align: 'left',
          headerAlign: 'left',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('INDEX.sample_name') || '样品名称',
          field: 'sampleName',
          minWidth: 350,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          // showOverflow: true,
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('form_label_stock_qty') || '库存数量',
          field: 'invNum',
          minWidth: 100,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('form_label_stock_location_no') || '存放库位',
          field: 'locationNo',
          minWidth: 120,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('INDEX.stock_form_location_desc') || '库位说明',
          field: 'locationDescription',
          minWidth: 150,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('INDEX.form_label_change_time') || '变动时间',
          field: 'modifyDate',
          minWidth: 170,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('INDEX.stock_form_sample_status') || '样品状态',
          field: 'sampleStatus',
          minWidth: 150,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          slots: { default: 'sampleStatus' }
        },
        {
          title:
            this.$l('INDEX.form_label_change_business_desc') || '变动业务说明',
          field: 'modifyDescription',
          minWidth: 200,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true
        }
      ]
    }
  },
  methods: {
    printTag() {
      // 缓存的选中数据，非当前页数据
      let reserveRecords = this.$refs.table.getCheckboxReserveRecords()
      // 当前页选中的数据
      let selectRecords = this.$refs.table.getCheckboxRecords()
      let totCount = reserveRecords.length + selectRecords.length
      if (totCount === 0) {
        this.$message.warning('请选择需要打印标签的样品信息')
        return false
      }
      if (totCount > 20) {
        this.$message.warning('一次打印的数量不能超过20个')
        return false
      }
      this.selectList = []
      // 将缓存中的选中数据，加入已选中数据列表
      if (reserveRecords.length > 0) {
        reserveRecords.forEach((row) => {
          this.selectList.push(row.sampleBarcode)
        })
      }
      // 将当前页选中数据，加入已选中数据列表
      if (selectRecords.length > 0) {
        selectRecords.forEach((row) => {
          this.selectList.push(row.sampleBarcode)
        })
      }
      this.print()
    },
    printPdf(sampleBarcode) {
      this.selectList = [sampleBarcode]
      this.print()
    },
    print() {
      if (this.selectList.length < 1) {
        this.$message({
          showClose: true,
          message: '请选择需要打印的标签',
          type: 'warning'
        })
        return
      }
      let data = { codeList: this.selectList }
      let fileName = '样品标签'
      this.$api.globalExportData(
        '/samplemanage/stockSampleLocation/print',
        data,
        fileName
      )
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
    }
  }
}
</script>
